"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _ButtonBase = require("../button/ButtonBase");

var _button = require("../button");

var _context = require("../context");

var _layout = require("../layout");

var _utils = require("../utils");

var _constants = require("./constants");

var _windowsHighContrastStyles = require("./windowsHighContrastStyles");

var _core = require("@emotion/core");

var _excluded = ["onClick", "onChange", "value", "children", "icon", "isSelected", "iconPosition", "disabled", "aria-disabled", "aria-label"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ToggleButtonBase = (0, _context.styledWithTheme)(_ButtonBase.ButtonBase)(function (_ref) {
  var disabled = _ref.disabled,
      iconOnly = _ref.iconOnly,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      selectors = _ref$theme.selectors,
      isInHighContrast = _ref$theme.isInHighContrast;
  var extendedStyles = {};
  var focusBorderColor = selectors.color('primary70');
  var outlineStyle = (0, _utils.addOutline)(_constants.OUTLINE_WIDTH, _constants.OUTLINE_OFFSET, focusBorderColor, {
    color: selectors.color('neutral0'),
    width: 1
  }, selectors.radius('R200'));

  if (isSelected) {
    extendedStyles = {
      backgroundColor: selectors.color('neutral90'),
      borderColor: selectors.color('neutral90'),
      borderWidth: _constants.BORDER_WIDTH,
      color: selectors.color('neutral0'),
      ':focus': _objectSpread(_objectSpread({}, outlineStyle.focus), {}, {
        borderRadius: selectors.radius('R100'),
        backgroundColor: selectors.color('neutral90')
      }),
      ':hover': {
        backgroundColor: selectors.color('neutral70')
      },
      ':active': {
        backgroundColor: selectors.color('neutral70')
      },
      ':disabled': {
        backgroundColor: selectors.color('neutral80'),
        borderRadius: 0
      }
    };
  } else {
    extendedStyles = {
      backgroundColor: selectors.color('neutral0'),
      borderColor: selectors.color('neutral50'),
      color: selectors.color('neutral90'),
      borderWidth: _constants.BORDER_WIDTH,
      ':focus': _objectSpread(_objectSpread({}, outlineStyle.focus), {}, {
        borderRadius: selectors.radius('R100')
      }),
      ':hover': {
        backgroundColor: selectors.color('neutral10')
      },
      ':active': {
        backgroundColor: selectors.color('neutral05')
      },
      ':disabled': {
        backgroundColor: selectors.color('neutral10'),
        borderRadius: 0,
        color: selectors.color('neutral60')
      }
    };
  }

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, extendedStyles), {}, {
    borderRadius: 0,
    margin: 0
  }, disabled && isSelected ? {
    color: selectors.color('neutral0'),
    backgroundColor: selectors.color('neutral70')
  } : {}), iconOnly && {
    padding: "0 ".concat((0, _utils.px)(selectors.space('S300')))
  }), isInHighContrast && (0, _windowsHighContrastStyles.getWindowsHighContrastStyles)(isSelected));
});
var ToggleButtonBaseWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var onClick = _ref2.onClick,
      onChange = _ref2.onChange,
      value = _ref2.value,
      children = _ref2.children,
      icon = _ref2.icon,
      isSelected = _ref2.isSelected,
      iconPosition = _ref2.iconPosition,
      disabled = _ref2.disabled,
      ariaDisabled = _ref2['aria-disabled'],
      ariaLabel = _ref2['aria-label'],
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var withoutChildren = !children && children !== 0 && children !== '';
  var iconOnly = !!icon && withoutChildren;
  var isButtonAriaDisabled = ariaDisabled && !disabled;
  var variant = isSelected ? _button.ButtonVariant.Primary : _button.ButtonVariant.Secondary;
  var handleChange = (0, _react.useCallback)(function (event) {
    if (onChange) {
      onChange(event, value);
    }
  }, [value, onChange]);
  var handleClick = (0, _react.useCallback)(function (event) {
    if (onClick) {
      onClick(event, value);
    }

    handleChange(event);
  }, [value, onClick, handleChange]);
  return (0, _core.jsx)(ToggleButtonBase, (0, _extends2.default)({
    iconOnly: iconOnly,
    ref: ref,
    "aria-disabled": isButtonAriaDisabled ? true : undefined,
    "aria-pressed": isSelected,
    "aria-label": ariaLabel,
    disabled: disabled,
    onClick: isButtonAriaDisabled ? undefined : handleClick,
    onChange: handleChange,
    isSelected: isSelected,
    variant: variant,
    size: _button.ButtonSize.Small
  }, props), iconOnly ? icon : (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    gridGap: "S100"
  }, !!icon && iconPosition === _button.ButtonIconPosition.Leading && icon, children, !!icon && iconPosition === _button.ButtonIconPosition.Trailing && icon));
});
ToggleButtonBaseWithoutDocs.defaultProps = {
  colorScheme: _button.ButtonColorScheme.Default,
  iconPosition: _button.ButtonIconPosition.Leading,
  shouldUseResponsiveContent: true,
  type: 'button'
};
var ToggleButtonBaseWithDocs = (0, _stencilReactDesc.describe)(ToggleButtonBaseWithoutDocs).description("Used to communicate an action that's initiated by clicking or tapping.");
ToggleButtonBaseWithDocs.propTypes = {
  value: _stencilReactDesc.PropTypes.string.description('Value set on selection.'),
  onChange: _stencilReactDesc.PropTypes.func.format("({\n    event: MouseEvent;\n    value: any;\n  }) => node"),
  onClick: _stencilReactDesc.PropTypes.func.format("({\n    event: MouseEvent;\n    value: any;\n  }) => node"),
  children: _stencilReactDesc.PropTypes.node.description('Displayed inside the clickable area of the button.'),
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the button from being clicked.'),
  'aria-disabled': _stencilReactDesc.PropTypes.bool.description('Prevents the button from being clicked, but allows putting focus.'),
  isSelected: _stencilReactDesc.PropTypes.bool.description('Determines whether the toggle button is currently selected by showing a visual indication.')
};
var ToggleButton = (0, _utils.withTestAttributes)({
  component: 'StencilReactToggleButton'
})(ToggleButtonBaseWithDocs);
ToggleButton.displayName = 'ToggleButton';
var _default = ToggleButton;
exports.default = _default;